const detectCardsLastRow = (slotQty, multiple) => {
  const completeCardRows = Math.floor(slotQty / multiple);
  const totalFullRowCards = completeCardRows * multiple;
  const rowsMod = slotQty % totalFullRowCards;

  if (rowsMod === 0) {
    return (completeCardRows - 1) * multiple - 1;
  }

  return totalFullRowCards - 1;
};

export default {
  detectCardsLastRow
};
